var map = {
	"./de.svg": 71363,
	"./en.svg": 86559,
	"./es.svg": 52362,
	"./fr.svg": 89730,
	"./id.svg": 23913,
	"./it.svg": 5593,
	"./nl.svg": 55756,
	"./pt.svg": 25038,
	"./ro.svg": 38547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22256;